import React, { useState, useEffect, useCallback } from 'react';
import { Archive, BookOpen, Search } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";

// --- DATA ARRAYS ---

const pillars = [{
  title: "Տարածական Լուծաչափ",
  description: "Մենք տրամադրում ենք բարձր ճշգրտության պատկերներ՝ 0.3մ-ից մինչև 2.5մ լուծաչափով, ապահովելով մանրակրկիտ դիտարկում ցանկացած նպատակի համար:",
  icon: Search,
  link: "/SatelliteImageAcquisitionPage"
}, {
  title: "Սպեկտրալ Տիրույթներ",
  description: "Հասանելի են պանխրոմատիկ, մուլտիսպեկտրալ և հիպերսպեկտրալ տվյալներ՝ բուսականության և հողային ծածկույթի խորը վերլուծության համար:",
  icon: Archive,
  link: "/SatelliteImageAcquisitionPage"
}, {
  title: "Ճշգրտություն և Ֆորմատ",
  description: "±3-5մ երկրաչափական ճշգրտություն և մթնոլորտային շտկում: Տվյալները տրամադրվում են GeoTIFF և COG ժամանակակից ֆորմատներով:",
  icon: BookOpen,
  link: "/SatelliteImageAcquisitionPage"
}];
const galleryImages = [{
  src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_07-scaled.jpg?v=suiz5dbzcgl",
  srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_07-scaled.jpg?v=9kzs4wrp9q",
  sizes: "100vw",
  alt: "Պաստառ 5"
}, {
  src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_10-scaled.jpg?v=qyytldsumq",
  srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_10-scaled.jpg?v=tmyrvepjfq",
  sizes: "100vw",
  alt: "Պաստառ 6"
}, {
  src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_01-scaled.jpg?v=mqkvw0a6png",
  srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_01-scaled.jpg?v=ljtc98t7urq",
  sizes: "100vw",
  alt: "Պաստառ 7"
}, {
  src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_03-scaled.jpg?v=b374svj6h7",
  srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_03-scaled.jpg?v=3e45l5napi5",
  sizes: "100vw",
  alt: "Պաստառ 11"
}, {
  src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_11-scaled.jpg?v=bit4e9zjsn",
  srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_11-scaled.jpg?v=gf9zmagz5be",
  sizes: "100vw",
  alt: "Պաստառ 10"
}, {
  src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_05-scaled.jpg?v=1glbneda7yc",
  srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_05-scaled.jpg?v=mrsqgzd2ke",
  sizes: "100vw",
  alt: "Պաստառ 9"
}, {
  src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_06-scaled.jpg?v=0764sn1lpky5",
  srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_06-scaled.jpg?v=p1f7voidop",
  sizes: "100vw",
  alt: "Պաստառ 3-1"
}, {
  src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_08-scaled.jpg?v=311i743ew44",
  srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_08-scaled.jpg?v=emyaa2dmmq7",
  sizes: "100vw",
  alt: "Պաստառ 3"
}, {
  src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_05-scaled.jpg?v=9qm7zp6b8qk",
  srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_05-scaled.jpg?v=h67rpo5273",
  sizes: "100vw",
  alt: "Պաստառ 8"
}, {
  src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_09-scaled.jpg?v=jt7c20bd8c",
  srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_09-scaled.jpg?v=ja33lk7vflf",
  sizes: "100vw",
  alt: "Պաստառ 2"
}, {
  src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_04-scaled.jpg?v=kxq7pz2sn0g",
  srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_12-SAR-1-scaled.jpg?v=qzv830ariz8",
  sizes: "100vw",
  alt: "Պաստառ 1"
}, {
  src: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_08-scaled.jpg?v=180kejnk6u9",
  srcset: "https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/Posters_1x1m_Feb_2026_b_08-scaled.jpg?v=8mgtixr2aol",
  sizes: "100vw",
  alt: "Պաստառ 12 SAR"
}];

// --- SECTIONS ---

// 1. Technical Specifications Section
function TechnicalSpecifications() {
  return;
}

// 2. Satellite Image Gallery Section
function SatelliteGallery() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const totalSlides = galleryImages.length;
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const nextSlide = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % totalSlides);
  }, [totalSlides]);
  const prevSlide = useCallback(() => {
    setCurrentIndex(prev => (prev - 1 + totalSlides) % totalSlides);
  }, [totalSlides]);
  const goToSlide = index => setCurrentIndex(index);
  const getSlideStyles = index => {
    let offset = index - currentIndex;
    if (offset < -Math.floor(totalSlides / 2)) offset += totalSlides;
    if (offset > Math.floor(totalSlides / 2)) offset -= totalSlides;
    const xOffset = isMobile ? 80 : 65;
    if (offset === 0) {
      return {
        transform: 'translateX(0) scale(1)',
        zIndex: 10,
        opacity: 1,
        filter: 'brightness(1)',
        pointerEvents: 'auto'
      };
    } else if (offset === -1) {
      return {
        transform: `translateX(-${xOffset}%) scale(0.85)`,
        zIndex: 5,
        opacity: 0.7,
        filter: 'brightness(0.4)',
        pointerEvents: 'auto'
      };
    } else if (offset === 1) {
      return {
        transform: `translateX(${xOffset}%) scale(0.85)`,
        zIndex: 5,
        opacity: 0.7,
        filter: 'brightness(0.4)',
        pointerEvents: 'auto'
      };
    } else {
      const direction = offset < 0 ? -1 : 1;
      return {
        transform: `translateX(${direction * 150}%) scale(0.5)`,
        zIndex: 1,
        opacity: 0,
        filter: 'brightness(0)',
        pointerEvents: 'none'
      };
    }
  };
  return <section id="gallery" className="bg-zinc-950 py-16 md:py-24 overflow-hidden relative">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight text-zinc-50 sm:text-4xl md:text-5xl">&nbsp;Օրինակներ</h2>
        </div>

        <div className="relative w-full max-w-6xl h-[350px] md:h-[500px] mx-auto flex items-center justify-center" style={{
        perspective: '1000px'
      }}>
          {galleryImages.map((image, index) => {
          const isCenter = index === currentIndex;
          return <img key={index} src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" onClick={() => {
            if (!isCenter) goToSlide(index);else setIsFullscreen(true);
          }} className={`absolute w-[75%] md:w-[60%] max-w-[700px] h-full object-cover rounded-2xl shadow-[0_15px_35px_rgba(0,0,0,0.6)] cursor-pointer will-change-transform ${isCenter ? 'hover:scale-[1.02] transition-transform' : ''}`} style={{
            ...getSlideStyles(index),
            transition: 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.5s ease, filter 0.5s ease'
          }} />;
        })}

          <button onClick={prevSlide} aria-label="Նախորդ նկար" className="absolute left-2 md:left-5 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-zinc-800/60 border border-white/10 text-white flex items-center justify-center backdrop-blur-sm transition-all hover:bg-zinc-700/90 active:scale-95">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6"><path d="m15 18-6-6 6-6" /></svg>
          </button>
          
          <button onClick={nextSlide} aria-label="Հաջորդ նկար" className="absolute right-2 md:right-5 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-zinc-800/60 border border-white/10 text-white flex items-center justify-center backdrop-blur-sm transition-all hover:bg-zinc-700/90 active:scale-95">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6"><path d="m9 18 6-6-6-6" /></svg>
          </button>

          <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 flex items-center gap-2 z-20">
            {galleryImages.map((_, index) => {
            const isActive = index === currentIndex;
            return <button key={index} onClick={() => goToSlide(index)} aria-label={`Գնալ սլայդ ${index + 1}`} className={`h-2.5 rounded-full transition-all duration-300 ${isActive ? 'w-8 bg-[#00d2ff]' : 'w-2.5 bg-zinc-600 hover:bg-zinc-500'}`} />;
          })}
          </div>
        </div>
      </div>

      {isFullscreen && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 backdrop-blur-md p-4 animate-in fade-in duration-300">
          <button onClick={() => setIsFullscreen(false)} className="absolute top-6 right-6 md:top-10 md:right-10 z-[110] w-12 h-12 rounded-full bg-zinc-800/80 border border-white/10 text-white flex items-center justify-center transition-all hover:bg-red-500/90 hover:scale-105 active:scale-95" aria-label="Փակել նկարը">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
          <img src={galleryImages[currentIndex].src} alt={galleryImages[currentIndex].alt} className="max-w-[95vw] max-h-[90vh] object-contain rounded-lg shadow-2xl scale-100" />
        </div>}
    </section>;
}

// --- MAIN PAGE EXPORT ---

export default function SatellitePage() {
  return <div className="w-full flex flex-col">
      {/* Renders the Cards first */}
      <TechnicalSpecifications />
      
      {/* Renders the Gallery directly below it */}
      <SatelliteGallery />
    </div>;
}